import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

/** While true, topbar.js skips scroll-up / reveal logic (internal in-page nav). */
export const CAMPICHE_SUPPRESS_TOPBAR_SCROLL_KEY = "__campicheSuppressTopbarAnchorScroll";

let suppressClearTimer = null;

function setTopbarSuppress(durationMs) {
  window[CAMPICHE_SUPPRESS_TOPBAR_SCROLL_KEY] = true;
  if (suppressClearTimer) {
    clearTimeout(suppressClearTimer);
  }
  suppressClearTimer = window.setTimeout(() => {
    window[CAMPICHE_SUPPRESS_TOPBAR_SCROLL_KEY] = false;
    suppressClearTimer = null;
  }, durationMs);
}

export default {
  init() {
    document.body.addEventListener("click", (event) => {
      const link = event.target.closest(".sidebar-nav a[href^='#']");
      if (!link) {
        return;
      }
      const href = link.getAttribute("href");
      if (!href || href === "#") {
        return;
      }
      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) {
        return;
      }

      event.preventDefault();

      const offset = 80;
      const targetY =
        target.getBoundingClientRect().top + window.pageYOffset - offset;

      const duration = 0.65;
      setTopbarSuppress(duration * 1000 + 400);

      gsap.to(window, {
        scrollTo: { y: targetY, autoKill: true },
        duration,
        ease: "power2.inOut",
      });
    });
  },
};
